<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="showForm = false">
      <div :class="{mobile_upload_order:mobiletype}">
      <h3 class="text-center"><i v-if="showForm" class="el-icon-arrow-left back" @click="showForm = false"></i>支付方式</h3>
      <div class="text-center" style="color:#888;font-size: 18px;margin-bottom: 10px;margin-top: 20px;" v-if="fromOrder">付款金额</div>
      <div class="text-center price" v-if="fromOrder">{{total_rate_amount|currency('¥')}}</div>
      <el-row v-if="!showForm">
        <el-col :span="24" class="tip select-payment-title">
          选择支付方式
        </el-col>
        <el-col :span="12" class="text-right">
          <!--<span class="pointer" @click="showForm = true"><i class="ico ico-add"></i> <span class="add-tip">添加地址</span></span>-->
        </el-col>
      </el-row>
      <el-row v-if="showForm">
        <el-col :span="24" class="tip add-card">
          添加一个新卡
        </el-col>
      </el-row>
      <FromCom :payment_way="order.offline_payment" :payment-id="paymentId" :company_account="company_account" :showForm="showForm" class="dialog-form" btnType="primary" :showOffPay="showOffPay" :singleID="singleID" :taskInfo="taskInfo" v-on:success="submit" v-on:addPayment="showForm = true"></FromCom>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FromCom from './Form'
import api from '../../../services/api.js'

export default {
  name: 'AddAddress',
  props: ['paymentId','singleID','order',"fromOrder",'mobiletype'],
  components: {
    FromCom: FromCom
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  created () {
    if(this.order.fee_adjustment_list){

      if(this.order.fee_adjustment_list.length>0){
        this.total_rate_amount = this.order.fee_adjustment_list[0].unpaid_fee_rmb
      }
      if(this.order.fee_adjustment_list.length==0){
        let t=(Number(this.order.total_amount) * Number(this.order.conditions.rate))
        this.total_rate_amount = this.$decimalFormat(t,2)
      }
    }else{
      let t2=(Number(this.order.total_amount) * Number(this.order.conditions.rate))
      this.total_rate_amount = this.$decimalFormat(t2,2)
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      showForm: false,
      total_rate_amount: null,
      showOffPay: true,
      company_account: null
    }
  },
  methods: {
    async show () {
      let res = await api.getUserInfo(this)
      this.company_account = res.body.result.company_account
      this.dialogFormVisible = true
      if(this.order.fee_adjustment_list){
        if(this.order.fee_adjustment_list.length==0){
          this.showOffPay = true
        }
        if(this.order.fee_adjustment_list.length>0){
          this.showOffPay = false
        }
      }else{
          this.showOffPay = true
      }
    },
    submit (data) {
      this.dialogFormVisible = false
      this.showForm = false
      this.$emit('success', data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 40px;
  }
  .tip {
    font-size:16px;
    color:rgba(136,136,136,1);
    line-height:24px;
    margin-bottom: 5px;
  }
  .add-tip {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:24px;
    margin-left: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-payment-title {
    font-size:16px;
    color: #888;
    line-height:14px;
    border-bottom: 1px solid #CDCDCD;
    padding-bottom: 12px;
  }

  .add-card {
    font-size:16px;
    color: #888;
    line-height:14px;
    margin-bottom: 20px;
  }
  .price {
    font-size: 38px;
    color: #333;
    margin-bottom: 20px;
  }
  .mobile_upload_order {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/payment/PaymentDialog.vue